export const actionTypes = {
  TOGGLE_MOBILE_MENU: "TOGGLE_MOBILE_MENU",
  CLOSE_MOBILE_MENU: "CLOSE_MOBILE_MENU",
  SET_SECONDS_AMOUNT: "SET_SECONDS_AMOUNT",
  SELECT_MOVIE: "SELECT_MOVIE",
  CREATE_ANSWER_OPTIONS: "CREATE_ANSWER_OPTIONS",
  SET_RESULTS: "SET_RESULTS",
  SET_IS_RESULT_VISIBLE: "SET_IS_RESULT_VISIBLE",
  SET_TIME_RANGE: "SET_TIME_RANGE",
  SET_IS_YOUTUBE_PLAYER_VISIBLE: "SET_IS_YOUTUBE_PLAYER_VISIBLE",
};
